<template>
  <div class="h-full bg-documentGray">
    <TopAppBar
      :title="title"
      :hideCategory="false"
      staticMode="true"
    >
    </TopAppBar>
    <div class="d-flex flex-column h-full">
      <TopAppBarDrawer></TopAppBarDrawer>
      <SocialLearningList v-if="!postId"></SocialLearningList>
      <transition mode="out-in" name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import SocialLearningList from "@/components/socialLearning/List";

export default {
  name: "socialLearning",

  data() {
    return {
      title: localStorage.getItem("brandName"),
      postId: null
    };
  },

  components: {
    TopAppBarDrawer,
    TopAppBar,
    SocialLearningList
  },

  mounted() {
    this.postId = this.$route.params.postId;
  }
};
</script>

<style scoped>
.fixed {
  position: fixed !important;
}
.bg-documentGray {
  background-color: var(--DocumentGray);
}
</style>
